







































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetShixunFenlei$ } from "@/request/shezhenjiaoxue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/left-nav.vue";
import PhotoPreview from "@/components/pic-preview.vue";
@Component({
  components: {
    MainHeader,
    LeftNav,
  },
})
export default class SzjxSzsx extends Vue {
  private cates: any[] = [];
  private shetai: any[] = [];
  private mian: any[] = [];
  private zonghe: any[] = [];
  private gexing: any[] = [];

  /**
   * @description 跳转智能学习报告
   */
  private jumpReport() {
    this.$router.push("/main/szjx/szsx-report");
  }
  /**
   * @description 获得舌诊分类
   */
  private fetchFenlei() {
    GetShixunFenlei$(this).then((data: any) => {
      console.log(data);
      this.cates = data;
      this.filterCates();
    });
  }
  /**
   * @description 将获得的结果分类
   */
  private filterCates() {
    this.cates.forEach((cate: any) => {
      if (cate.cate_id === "舌色类实训题") {
        cate["名称"] = "舌色类";
        this.shetai.push(cate);
      } else if (cate.cate_id === "舌形类实训题") {
        cate["名称"] = "舌形类";
        this.shetai.push(cate);
      } else if (cate.cate_id === "舌质类实训题") {
        cate["名称"] = "舌质类";
        this.shetai.push(cate);
      } else if (cate.cate_id === "苔色类实训题") {
        cate["名称"] = "苔色类";
        this.shetai.push(cate);
      } else if (cate.cate_id === "苔质类实训题") {
        cate["名称"] = "苔质类";
        this.shetai.push(cate);
      } else if (cate.cate_id === "面色类实训题") {
        cate["名称"] = "面色类";
        this.mian.push(cate);
      } else if (cate.cate_id === "面部局部特征类实训题") {
        cate["名称"] = "面部局部特征类";
        this.mian.push(cate);
      } else if (cate.cate_id === "光泽类实训题") {
        cate["名称"] = "光泽类";
        this.mian.push(cate);
      } else if (cate.cate_id === "唇色类实训题") {
        cate["名称"] = "唇色类";
        this.mian.push(cate);
      } else if (cate.cate_id === "诊断学习") {
        cate["名称"] = "诊断学习";
        this.zonghe.push(cate);
      } else if (cate.cate_id === "考研模拟") {
        cate["名称"] = "考研模拟";
        this.zonghe.push(cate);
      } else if (cate.cate_id === "执医真题") {
        cate["名称"] = "执医真题";
        this.zonghe.push(cate);
      } else {
        this.gexing.push(cate);
      }
    });
  }
  /**
   * @description 跳转详情
   */
  private jumpDetail(id, name) {
    this.$router.push({
      path: "/main/szjx/szsx-detail",
      query: {
        id,
        name,
      },
    });
  }
  /**
   * @description 跳转模拟测试
   */
  private jumpMoni() {
    this.$router.push("/main/szjx/szsx-moni");
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchFenlei();
  }
}
